import React from 'react';
import UnavailablePage from './UnavailablePage';
export default function Schedule() {
  return <UnavailablePage title="Your Schedule" description="Shared appointments and meeting requests are not connected yet. Mentors can save their own office hours from Profile." />;
}
